import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

const Home = () => {
  const [ref1, inView1] = useInView({ threshold: 0.1 });
  const [ref2, inView2] = useInView({ threshold: 0.1 });
  const [ref3, inView3] = useInView({ threshold: 0.1 });
  const [ref4, inView4] = useInView({ threshold: 0.1 });
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/calculate'); // Update with the correct path to your calculation page
  };

  return (
    <div className="bg-green-100 text-gray-800">
      <motion.section
        className="h-screen flex items-center justify-center bg-green-500 text-white"
        ref={ref1}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: inView1 ? 1 : 0, y: inView1 ? 0 : 50 }}
        transition={{ duration: 1 }}
      >
        <div className="text-center px-4">
          <h1 className="text-5xl font-bold">Welcome to Our Environment First Initiative</h1>
          <p className="mt-4 text-xl">Join us in making the world a better place.</p>
        </div>
      </motion.section>

      <motion.section
        className="min-h-screen flex flex-col md:flex-row items-center justify-center bg-green-200"
        ref={ref2}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: inView2 ? 1 : 0, y: inView2 ? 0 : 50 }}
        transition={{ duration: 1 }}
      >
        <div className="w-full md:w-1/2 p-8">
          <h2 className="text-4xl font-bold">Our Mission</h2>
          <p className="mt-4 text-lg">
            Our mission is to serve the industry by providing robust data processing solutions
            required for completing forms and reports essential for legal compliance with
            environmental obligations. We aim to streamline the compliance process, ensuring
            that industries can meet their environmental responsibilities efficiently and
            effectively.
          </p>
        </div>
        <div className="w-full md:w-1/2 p-8">
          <img src="https://www.telefonica.com/en/wp-content/uploads/sites/5/2024/01/pexels-photo-1108572-e1706694279617.jpeg" alt="Environment" className="w-full h-full object-cover rounded-lg shadow-lg" />
        </div>
      </motion.section>

      <motion.section
        className="min-h-screen flex flex-col md:flex-row-reverse items-center justify-center bg-green-300"
        ref={ref3}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: inView3 ? 1 : 0, y: inView3 ? 0 : 50 }}
        transition={{ duration: 1 }}
      >
        <div className="w-full md:w-1/2 p-8">
          <h2 className="text-4xl font-bold">What's there for you</h2>
          <p className="mt-4 text-lg">
            To start with, we are providing a backup calculation facility for air pollutants emitted to the environment. This information is primarily required while filing environmental statements.
          </p>
        </div>
        <div className="w-full md:w-1/2 p-8">
          <img src="https://www.repsol.com/content/dam/repsol-corporate/es/energia-e-innovacion/manos-tierra-nino.jpg" alt="How You Can Help" className="w-full h-full object-cover rounded-lg shadow-lg" />
        </div>
      </motion.section>

      <motion.section
        className="min-h-screen flex flex-col md:flex-row items-center justify-center bg-green-400"
        ref={ref4}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: inView4 ? 1 : 0, y: inView4 ? 0 : 50 }}
        transition={{ duration: 1 }}
      >
        <div className="w-full md:w-1/2 p-8">
          <h2 className="text-4xl font-bold">Requirements</h2>
          <p className="mt-4 text-lg">
            To get this output the information required is <strong>Flue gas/ Stack monitoring</strong> report of the source (DG, Boiler, Furnace etc.) and its running hours in the corresponding financial year.
          </p>
          <div className="flex justify-center mt-8">
            <button
              onClick={handleButtonClick}
              className="relative px-6 py-3 font-bold text-white rounded-lg transition-transform duration-300 focus:outline-none focus:ring-2 focus:ring-green-900 text-2xl shiny-button"
              style={{
                background: 'linear-gradient(90deg, rgba(6, 78, 59, 1) 0%, rgba(6, 78, 59, 0.8) 50%, rgba(6, 78, 59, 1) 100%)',
                animation: 'blink 1.5s infinite, shine 2s linear infinite, glow 1.5s infinite alternate',
                boxShadow: '0 8px 16px rgba(6, 78, 59, 0.8), 0 0 20px rgba(6, 78, 59, 0.6), 0 0 30px rgba(6, 78, 59, 0.4)',
              }}
            >
              <span className="absolute inset-0 w-full h-full bg-green-900 opacity-80 rounded-lg animate-blink"></span>
              <span className="relative z-10">CALCULATE</span>
            </button>

          </div>
        </div>
        <div className="w-full md:w-1/2 p-8">
          <img src="https://mapmygenome.in/cdn/shop/articles/World_Environment_Day.jpg?v=1717569248" alt="Get Involved" className="w-full h-full object-cover rounded-lg shadow-lg" />
        </div>
      </motion.section>
      <Footer />
    </div>
  );
};

export default Home;
